import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Select, Switch } from "antd";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import { getBase64Img } from "utils";

export const EditProductModal: React.FC<any> = ({ ...props }) => {
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const [option, setOption] = useState<string>("");

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		productStatus,
		currentImgURL,
		setProductStatus,
		productIsHighlight,
		setProductIsHighlight,
		currentProductInfo,
		onUpdated
	} = props;
	const { Option } = Select;

	const handleRegister = (values: any) => {
		api
			.put(`/products/${currentProductInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					onUpdated(result.data)
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentProductInfo?.title,
				description: currentProductInfo?.description,
				link: currentProductInfo?.link,
				visibility:
					currentProductInfo?.visibility === "public" ? "public" : "private",
			});
			setOption(
				currentProductInfo?.visibility === "public" ? "public" : "private"
			);
			setCurrentImgURL(
				currentProductInfo?.image ? currentProductInfo?.image : ""
			);
			setProductStatus(currentProductInfo?.status === "publish" ? true : false);
			setProductIsHighlight(
				currentProductInfo?.is_highlight === true ? true : false
			);
			setIsActive(currentProductInfo?.is_active === true ? true : false);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	const handleChangeImage = (imageUrl: string) => {
		setImageWasEdited(true)
		setCurrentImgURL(imageUrl)
	} 
	
	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar produto</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar produto"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									status: productStatus ? "publish" : "pending",
									is_highlight: productIsHighlight,
									visibility: option ? option : "",
									is_active: isActive,
									image: currentImgURL,
							  }
							: {
									...values,
									status: productStatus ? "publish" : "pending",
									is_highlight: productIsHighlight,
									visibility: option ? option : "",
									is_active: isActive,
							  };

						handleRegister(allValues);
						setCurrentImgURL("");
						setProductStatus(false);
						setProductIsHighlight(false);
						setIsActive(false);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				setProductStatus(false);
				setProductIsHighlight(false);
				setIsActive(false);
				form.resetFields();
			}}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={handleChangeImage}/>
				
				<div className="row mt-2">
					<Form.Item
						label="Título"
						name="title"
						rules={[
							{
								required: true,
								message: "Título necessário",
							},
						]}
					>
						<Input placeholder="Título do produto" />
					</Form.Item>
					<Form.Item
						label="Descrição"
						name="description"
						rules={[
							{
								required: true,
								message: "Descrição necessária",
							},
						]}
					>
						<Input placeholder="Descrição do produto" />
					</Form.Item>
					<Form.Item
						label="Link"
						name="link"
						rules={[
							{
								required: true,
								message: "Link necessário",
							},
						]}
					>
						<Input placeholder="Link do produto" />
					</Form.Item>

					<div className="row pe-0">
						<div className="col-12 col-md-4 pe-0">
							<Form.Item
								label="Visibilidade"
								name="visibility"
								rules={[
									{
										required: true,
										message: "Visibilidade necessária",
									},
								]}
								style={{ margin: 0, width: "100%" }}
							>
								<Select
									placeholder="Visibilidade"
									className="m-product-modal__select"
									value={option}
									onChange={(e) => setOption(e)}
								>
									<Option value="public">Público</Option>
									<Option value="private">Privado</Option>
								</Select>
							</Form.Item>
						</div>

						<div className="col-12 col-md-8 row row-cols-3 pb-3 align-items-center text-center">
							<div>
								<p>Publicado</p>
								<Switch
									checked={productStatus}
									onClick={(e) => setProductStatus(e)}
								/>
							</div>
							<div>
								<p>Destacar</p>
								<Switch
									checked={productIsHighlight}
									onClick={(e) => setProductIsHighlight(e)}
								/>
							</div>
							<div>
								<p>Ativo</p>
								<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
							</div>
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
